import { addSavedOffer } from '@cian/favorites-assign-widget';
import { addToFavorite as _addToFavorite } from '../../services/addToFavorite';
import { TThunkAction } from '../../types/redux/thunk';
import { updateFavorite } from '../promoOffers';

export const addToFavorite =
  (offerId: number): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      const addToFavoriteResult = await _addToFavorite(context, { offerId });
      dispatch(updateFavorite({ offerId, isFavorite: true }));

      const userHasFolders = Boolean(addToFavoriteResult.hasFolders);
      const folder = addToFavoriteResult.folder;

      const savedInFolders =
        folder && folder.name && folder.id
          ? [
              {
                id: folder.id,
                name: folder.name,
              },
            ]
          : null;

      dispatch(addSavedOffer({ offerIds: [offerId], savedInFolders, userHasFolders }));
    } catch (error) {
      context.logger.error(error, {
        offerId,
        domain: 'addToFavorite',
      });
    }
  };
